export class HttpNotConfigException extends Error {
    constructor(key?: string) {
        super();
        this.name = "HttpNotConfigException";

        if (key) {
            this.message = "没有相关的HTTP配置：" + key;
        }
    }
}